function getDailyRandom(min, max) {
  const now = new Date();
  const daySeed = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
  const hash = Array.from(daySeed).reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return min + (hash % (max - min + 1));
}

document.addEventListener("DOMContentLoaded", function () {
  const number = getDailyRandom(81, 99);
  const target = document.querySelector('.socialproof-inline-text b:last-of-type');
  if (target) {
    target.textContent = number + ' anderen';
  }
});
